export default "__VITE_ASSET__8552e01d__"